import React, { ChangeEvent } from "react";
import {
  TextField,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  MenuItem,
  Select,
  Button,
  CardMedia,
  IconButton,
  Input,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import EditText from "../../components/editText";

const recipientTypes = ["Customers", "Dealers"];

const mockRecipients: any = {
  Customers: [
    { id: "1", label: "Customer 1" },
    { id: "2", label: "Customer 2" },
    { id: "3", label: "Customer 3" },
  ],
  Dealers: [
    { id: "4", label: "Dealer 1" },
    { id: "5", label: "Dealer 2" },
  ],
};

const AddNotification = () => {
  const navigate = useNavigate();

  const [image, setImage] = React.useState<string>("");
  const [fileName, setFileName] = React.useState<string>("");

  const [type, setType] = React.useState("default");

  const [legal1, setLegal1] = React.useState<string>("");

  // MULTIPLE ROLES
  const [selectedRecipients, setSelectedRecipients] = React.useState<string[]>([]);
  const [availableCustomers, setAvailableCustomers] = React.useState<any[]>([]);
  const [selectedCustomers, setSelectedCustomers] = React.useState<any[]>([]);

  // Handle Role Selection (Multi)
  const handleRecipientsChange = (event: any, value: string[]) => {
    setSelectedRecipients(value);
    setSelectedCustomers([]);

    const combinedCustomers = value
      .map((type) => mockRecipients[type] || [])
      .flat();

    setAvailableCustomers(combinedCustomers);
  };

  // Handle Customers Select
  const handleCustomersChange = (event: any, value: any[]) => {
    setSelectedCustomers(value);
  };

  const handleTypeChange = (event: any) => {
    setType(event.target.value);
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Notification</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
          <button onClick={() => navigate("/manage-notifications")}>Notification Management</button> -
          Add Notification
        </p>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">

            {/* Upload Image */}
            <div className="control_group w_100">
              <label htmlFor="upload">Upload Image (optional)</label>
              {image ? (
                <div className="upload_image no_radius">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="Uploaded" />
                    </figure>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                </div>
              ) : (
                <label className="upload_image no_radius" htmlFor="upload">
                  <Input
                    sx={{ display: "none" }}
                    id="upload"
                    type="file"
                    inputProps={{ accept: "image/png,image/jpeg" }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = event.target.files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img src="/static/images/placeholder.png" alt="icon" />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            {/* Notification Title */}
            <div className="control_group w_50">
              <label>Notification Title</label>
              <TextField placeholder="Enter Notification Title" fullWidth />
            </div>

            {/* Notification Type */}
            <div className="control_group w_50">
              <label>Type</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Type
                </MenuItem>
                <MenuItem value="broadcast">Broadcast</MenuItem>
                <MenuItem value="email">Email</MenuItem>
                <MenuItem value="push">Push Notification</MenuItem>
              </Select>
            </div>

            {/* MULTIPLE ROLES SELECTION */}
            <div className="control_group w_100">
              <label>Select Recipients</label>
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={recipientTypes}
                value={selectedRecipients}
                onChange={handleRecipientsChange}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <FormControlLabel
                      control={<Checkbox checked={selected} />}
                      label={option}
                    />
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Recipients" />
                )}
              />
            </div>

            {/* USERS DROPDOWN */}
            {selectedRecipients.length > 0 && (
              <div className="control_group w_100">
                <label>Select {selectedRecipients.join(" & ")}</label>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={availableCustomers}
                  value={selectedCustomers}
                  onChange={handleCustomersChange}
                  getOptionLabel={(option) => option.label}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <FormControlLabel
                        control={<Checkbox checked={selected} />}
                        label={option.label}
                      />
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select from list" />
                  )}
                />
              </div>
            )}

            {/* Notification Message */}
            <div className="control_group w_100">
              <label>Notification Message</label>
              <EditText content={legal1} setContent={setLegal1} />
            </div>
          </div>

          <div className="form_btn">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-notifications")}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddNotification;
